import { Backoffice } from '@quickbit/backoffice-core-frontend';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { tabsData } from './tabs';

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      const environment = ' ' + (process.env.REACT_APP_ENVIRONMENT || '');
      document.title = document.title.replaceAll(environment, '');
      document.title += environment;
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Backoffice tabs={tabsData} merchantName={undefined} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
